import { Link } from "react-router-dom";

export default function Support() {
  const topics = [
    { icon: "🔐", title: "Account & Login", desc: "Password reset, account recovery, profile settings.", link: "/contact" },
    { icon: "⚔️", title: "Battles & Disputes", desc: "Report cheating, battle score issues, challenge bugs.", link: "/contact" },
    { icon: "🗺️", title: "Territory Issues", desc: "Wrong territory assignments, map display problems.", link: "/contact" },
    { icon: "💰", title: "Coins & Rewards", desc: "Missing coins, failed reward claims, wallet issues.", link: "/contact" },
    { icon: "📱", title: "App Performance", desc: "Crashes, GPS issues, sync problems.", link: "/contact" },
    { icon: "🔒", title: "Privacy & Data", desc: "Data deletion, privacy questions, data export.", link: "/delete-data" },
  ];

  return (
    <div style={{ background: "var(--bg)", minHeight: "100vh", paddingTop: 80, overflowX: "hidden" }}>
      <style>{`
        .wb-support-section {
          padding: 80px 48px;
          max-width: 1100px;
          margin: 0 auto;
        }

        .wb-support-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(min(100%, 300px), 1fr));
          gap: 18px;
          margin-bottom: 56px;
        }

        .wb-support-box {
          background: linear-gradient(135deg, rgba(0,245,196,0.06), rgba(123,97,255,0.06));
          border: 1px solid rgba(0,245,196,0.15);
          border-radius: 16px;
          padding: 40px 32px;
          text-align: center;
        }

        /* Tablet (768px - 1024px) */
        @media (max-width: 1024px) {
          .wb-support-section {
            padding: 60px 28px;
          }
          .wb-support-grid {
            gap: 16px;
            margin-bottom: 48px;
          }
        }

        /* Mobile (< 640px) */
        @media (max-width: 640px) {
          .wb-support-section {
            padding: 48px 16px;
          }
          .wb-support-grid {
            grid-template-columns: 1fr;
            gap: 14px;
            margin-bottom: 36px;
          }
          .wb-support-box {
            padding: 28px 18px;
          }
        }
      `}</style>

      <section className="wb-support-section">
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
              background: "rgba(0,245,196,0.07)",
              border: "1px solid rgba(0,245,196,0.2)",
              padding: "6px 16px",
              borderRadius: 100,
              marginBottom: 18,
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: 11,
              color: "var(--neon)",
              letterSpacing: 3,
              textTransform: "uppercase",
            }}
          >
            🛠 Support
          </div>
          <h1
            style={{
              fontFamily: "'Orbitron', monospace",
              fontSize: "clamp(26px, 5vw, 48px)",
              fontWeight: 900,
              color: "var(--text)",
              marginBottom: 14,
              lineHeight: 1.1,
            }}
          >
            How Can We <span style={{ color: "var(--neon)" }}>Help?</span>
          </h1>
          <p style={{ color: "var(--muted)", fontSize: "clamp(14px, 2vw, 16px)", lineHeight: 1.7, maxWidth: 480, margin: "0 auto" }}>
            Pick a topic below or contact our team directly. We respond within 24 hours.
          </p>
        </div>

        <div className="wb-support-grid">
          {topics.map(({ icon, title, desc, link }) => (
            <Link
              key={title}
              to={link}
              style={{
                background: "var(--surface)",
                border: "1px solid var(--border)",
                borderRadius: 12,
                padding: "24px 20px",
                textDecoration: "none",
                display: "block",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.borderColor = "rgba(0,245,196,0.3)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "none";
                e.currentTarget.style.borderColor = "var(--border)";
              }}
            >
              <div style={{ fontSize: 30, marginBottom: 14 }}>{icon}</div>
              <h3
                style={{
                  fontFamily: "'Orbitron', monospace",
                  fontSize: 15,
                  fontWeight: 700,
                  color: "var(--text)",
                  marginBottom: 6,
                }}
              >
                {title}
              </h3>
              <p style={{ color: "var(--muted)", fontSize: 13, lineHeight: 1.6 }}>{desc}</p>
              <div style={{ color: "var(--neon)", fontSize: 12, marginTop: 12, fontFamily: "monospace", fontWeight: 700 }}>
                Get Help →
              </div>
            </Link>
          ))}
        </div>

        <div className="wb-support-box">
          <h2 style={{ fontFamily: "'Orbitron', monospace", fontSize: "clamp(18px, 3.5vw, 24px)", fontWeight: 900, color: "var(--text)", marginBottom: 10 }}>
            Still need help?
          </h2>
          <p style={{ color: "var(--muted)", marginBottom: 20, fontSize: 15 }}>
            Our support team is available Monday–Saturday, 9AM–6PM IST.
          </p>
          <Link
            to="/contact"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              background: "var(--neon)",
              color: "var(--bg)",
              padding: "14px 32px",
              borderRadius: 6,
              fontFamily: "'Orbitron', monospace",
              fontSize: 11,
              fontWeight: 800,
              letterSpacing: 2,
              textDecoration: "none",
              textTransform: "uppercase",
              boxShadow: "0 0 20px rgba(0,245,196,0.3)",
            }}
          >
            📧 Contact Support
          </Link>
        </div>
      </section>
    </div>
  );
}

